import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'replaceAtSign'})
export class ReplaceAtSignPipe implements PipeTransform {
  transform(value: string): string {
    return value ?
      value.replace(/@/g, '(at)') : value;
  }
}
